// dataLayer event names; the GTM container maps each one to a GA4 event
export enum AnalyticsEventEnum {
  Click = 'sc_click',
  PageView = 'sc_page_view',
  MapLayer = 'sc_map_layer',
  ApiError = 'sc_api_error',
  ApiSlow = 'sc_api_slow',
  WebVital = 'sc_web_vital',
  ActionSuccess = 'sc_action_success',
  ListFilter = 'sc_list_filter',
}

// The track ids GTM maps to GA4 key events (LT - Key event name). Each one is also reported as
// sc_action_success once the API confirms the action, and that is what GA4 counts.
export enum KeyActionEnum {
  DealCreate = 'deal.create-form.save',
  ClosedDealCreate = 'deal.closed-create.save',
  PropertyCreate = 'property.create-form.save',
  AvailabilityCreate = 'availability.create-form.save',
  ComparableCreate = 'comparable.create.save',
  CompanyCreate = 'company.create.save',
  ContactCreate = 'contact.wizard.save',
  OccupierCreate = 'occupier.create-form.save',
  OccupierWizardCreate = 'occupier.create-wizard.save',
  RequirementCreate = 'requirement.create-form.save',
  PresentationCreate = 'presentation.create-form.save',
  SavedSetCreate = 'saved-set.create-form.save',
  InvoiceSend = 'deal.invoice.send',
  EblastSend = 'marketing.eblast.send',
  CampaignSend = 'marketing.campaign.send',
  PressReleaseSend = 'marketing.press-release.send',
  PressReleaseApprove = 'marketing.press-release.approve',
  AvailabilityIngestionApprove = 'availability.ingestion-approve.confirm',
  LeaseIngestionApprove = 'occupier.lease-ingestion-approve.confirm',
  ListExport = 'list.selection.export',
}

export enum MapLayerActionEnum {
  On = 'on',
  Off = 'off',
}

export enum ApiErrorTypeEnum {
  // the API answered with an error status
  Http = 'http',
  // no answer at all: offline, timeout, CORS, or the request never left the browser
  Network = 'network',
}

// how long a slow API request took, as reported in duration_bucket
export enum ApiDurationBucketEnum {
  UpTo5s = '3-5s',
  UpTo10s = '5-10s',
  Over10s = '10s+',
}

// what a sc_list_filter event reports: a filter field added, a text search started, or a new sort
export enum ListFilterTypeEnum {
  Filter = 'filter',
  Search = 'search',
  Sort = 'sort',
}

export enum SortDirectionEnum {
  Asc = 'asc',
  Desc = 'desc',
}
